import { useAppSelector } from 'app/hooks';
import { UserGroup } from 'common/types/Entities';
import { useFetchUserGroupsByTenantId } from 'features/reports/hooks/useFetchUserGroupsByTenantId';
import { selectUserGroups } from 'features/userGroups/userGroupsSlice';

import { MultiSelectDropdown } from './MultiSelectDropdown';

export function UserGroupsMultipleSelectDropDown(props: Readonly<{
        tenantId: string,
        value: UserGroup[],
        onChange: (userGroups: UserGroup[]) => void,
    }>) {
    const { tenantId, value, onChange } = props;
    const userGroups = useAppSelector(selectUserGroups);

    useFetchUserGroupsByTenantId(onChange, tenantId);

    return (
        <MultiSelectDropdown
            disabled={!tenantId}
            value={value}
            onChange={onChange}
            options={userGroups}
            getOptionLabel={opt => opt.name}
            label="User Groups"
            noOptionsText="User Groups not found"
        />
    );
}
